import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Styles/AdminViewReports.css";
import { Link } from "react-router-dom";
import Loader from "../../Components/Loader";

function AdminViewReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(null);

  // Store temporary status and remarks for each report
  const [tempUpdates, setTempUpdates] = useState({});

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.get(
        "https://api.uniums.com/api/reports/all-reports",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setReports(response.data.reports);

      // Initialize temporary updates state
      const initialUpdates = {};
      response.data.reports.forEach((report) => {
        initialUpdates[report._id] = {
          status: report.status,
          remark: report.remark,
        };
      });
      setTempUpdates(initialUpdates);
    } catch (error) {
      console.error("Error fetching reports:", error);
      toast.error("Failed to fetch reports.");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (reportId) => {
    setUpdating(reportId);
    const token = localStorage.getItem("authToken");

    try {
      await axios.post(
        `https://api.uniums.com/api/reports/update-report/${reportId}`,
        tempUpdates[reportId], // Send updated status and remark
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Report updated successfully!");
      fetchReports();
    } catch (error) {
      console.error("Error updating report:", error);
      toast.error("Failed to update report.");
    } finally {
      setUpdating(null);
    }
  };

  return (
    <div className="admin-container">
      <ToastContainer />
      <h1>View All Reports</h1>
      <div className="history_div">
        <Link to={"/report-history"}>Reports History</Link>
      </div>

      {loading ? (
        <>
          <p className="loading">Loading reports...</p>
          <Loader />
        </>

      ) : (
        <div className="faculty-table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Issue Type</th>
                <th>Urgency</th>
                <th>Issue Date</th>
                <th>Title</th>
                <th>Description</th>
                <th>Screenshot</th>
                <th>Status</th>
                <th>Remark</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {reports.map((report, index) => (
                <tr key={report._id}>
                  <td>{index + 1}</td>
                  <td>{report.UserId.name}</td>
                  <td>{report.issueType}</td>
                  <td>{report.urgency}</td>
                  <td>
                    {new Date(report.createdAt).toLocaleDateString("en-GB")}
                  </td>
                  <td style={{
                    padding: "10px",
                    minWidth: "200px",
                    maxWidth: "200px",
                    maxHeight: "200px",
                    overflow: "auto",
                    whiteSpace: "normal",
                  }}>{report.title}</td>
                  <td
                    style={{
                      padding: "10px",
                      minWidth: "200px",
                      maxWidth: "200px",
                      maxHeight: "200px",
                      overflow: "auto",
                      display: "block",
                      whiteSpace: "normal",
                    }}
                  >
                    {report.description}
                  </td>
                  <td>
                    {report.fileUrl ? (
                      <a
                        href={report.fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={report.fileUrl}
                          alt="Screenshot"
                          className="screenshot"
                        />
                      </a>
                    ) : (
                      "No Screenshot"
                    )}
                  </td>
                  <td>
                    <select
                      value={tempUpdates[report._id]?.status || ""}
                      onChange={(e) =>
                        setTempUpdates({
                          ...tempUpdates,
                          [report._id]: {
                            ...tempUpdates[report._id],
                            status: e.target.value,
                          },
                        })
                      }
                      className="status-dropdown"
                    >
                      <option value="Pending">Pending</option>
                      <option value="In Progress">In Progress</option>
                      <option value="Resolved">Resolved</option>
                    </select>
                  </td>
                  <td>
                    <textarea
                      className="remark-input"
                      style={{
                        width: "250px",
                        height: "100px",
                        padding: "5px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        resize: "none",
                      }}
                      value={tempUpdates[report._id]?.remark || ""}
                      onChange={(e) =>
                        setTempUpdates({
                          ...tempUpdates,
                          [report._id]: {
                            ...tempUpdates[report._id],
                            remark: e.target.value,
                          },
                        })
                      }
                      placeholder="Add remark..."
                    />
                  </td>
                  <td>
                    <button
                      className="update-button"
                      onClick={() => handleUpdate(report._id)}
                      disabled={updating === report._id}
                    >
                      {updating === report._id ? "Updating..." : "Update"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default AdminViewReports;
